import React,{Component} from 'react';
import { ref } from '../config/constants'
import {formatPrice} from '../helpers/helpers'

class QMiscellaneous extends Component{
    constructor(){
        super();

    this.handleTotal = this.handleTotal.bind(this);
    this.delete = this.delete.bind(this)
        this.state = {
            product :{},
            total : 0                 
        }
    }

    componentWillMount(){
        let prodData = ref.child("Products").child(this.props.product)
            prodData.on("value",function(data){
                
                    this.setState({
                        product : data.val()
                    })
                    //this.props.setProduct(data.val(),this.props.index)
                    
            }.bind(this))                                      
    }

    handleTotal(e){
        let total = e.target.value * this.productPrice.value
            total = total.toFixed(2)

            this.setState({
                total
            })

            let product = this.state.product
            var labor =  product.laborPrice_4MM
            let update = {
                ...product,
                laborPrice : labor,
                number :parseInt(e.target.value,10)
            }

            this.setState({
                product : update
            })
    }
    
    delete(index){
        this.props.remove(index)
        this.props.removeTotal(index)
    }

    componentDidUpdate(prevProps,prevState){
        if(prevState.product !== this.state.product){
            if(this.state.product.name !== "G.I. Wire"){
            this.props.setProductsLabor(this.state.product,this.props.index)
            }
        }

        if(prevState.total !== this.state.total){
            this.props.getTotal2(this.props.index,this.state.total)
            //this.props.setProductsLabor(this.state.product,this.props.index)
        }
    }
    render() {       
            
        return (
            
                    <tr>

                        <td>
                            <div className="row nomarginLR">
                                <div className="col-lg-7 col-md-5 nopaddingLR">
                                    <p className="text-uppercase">{this.state.product.name}</p>
                                </div>
                                <div className="col-lg-5 col-md-3 nopaddingLR">
                                    <button type="button" className="btn btn-sm btn-danger" onClick={()=>this.delete(this.props.index)}><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                                </div>
                            </div>
                            
                            <input type="hidden" className="form-control" name="productName" ref={input => this.productName = input} value={this.state.product.name}/>
                            <input type="hidden" className="form-control" name="category" ref={input => this.category = input} value="Miscellaneous"/>
                            <input type="hidden" className="form-control" name="productId" ref={input => this.productId = input} value={this.props.product}/>
                        </td>
                        <td>
                            <input type="hidden" className="form-control" name="productName" ref={input => this.productDimension = input} value="N/A"/>
                        </td>
                        <td>
                            <input type="hidden" className="form-control" name="productName" ref={input => this.productThickness = input} value="N/A"/>
                        </td>
                        <td>                          
                                <input type="text" className="form-control" name="productNumber" ref={input => this.productNumber = input}  onChange={this.handleTotal} />
                            
                        </td>
                         <td>
                            <p>{`${this.state.product.unit}`}
                                <input type="hidden" className="form-control" name="productUnit" ref={input => this.productUnit = input} value={this.state.product.unit} />
                            </p>
                        </td>
                        
                        <td>
                            <p>{this.state.product.price_4MM}
                                <input type="hidden" className="form-control" name="productPrice" ref={input => this.productPrice = input} value={this.state.product.price_4MM}  />
                            </p>
                        </td>

                        <td>
                            <p>{`/${this.state.product.unit}`}
                                <input type="hidden" className="form-control" name="productUnit" ref={input => this.productUnit = input} value={this.state.product.unit} />
                            </p>
                        </td>
                        <td>
                           <input type="hidden" className="form-control"  name="productDiscount" ref={input => this.productDiscount = input} value={0} onChange={this.handleDiscount} />
                        </td>
                        <td>
                            <p>{formatPrice(this.state.total)}</p>
                            <input type="hidden" className="form-control" name ="productTotal" ref={input => this.productTotal = input} value={this.state.total} />
                        </td>
                    </tr>
                
 
        );
    }
}

export default  QMiscellaneous;


// WEBPACK FOOTER //
// ./src/components/QMiscellaneous.js